import React from 'react'
import {
  PhoneNumberInput,
  VerifyPhoneNumberFailureFragment,
  VerifyPhoneNumberResourceType,
} from 'src/graphql/generated/graphql'
import { PhoneNumberVerificationDialog } from './PhoneNumberVerificationDialog'
import { usePhoneNumberVerifyForResource } from 'src/react_query'

type PhoneNumberVerificationDialogGetActJWTProps = {
  hero?: JSX.Element
  title: string
  subtitle?: string
  resourceType: VerifyPhoneNumberResourceType
  resourceId: string
  initialPhoneNumber?: PhoneNumberInput
  allowedPhoneNumber?: PhoneNumberInput
  anchorButton?: {
    label: string
    action: () => void
  }
  onClose: () => void
  onSuccess: (jwt: string) => void
}

export const PhoneNumberVerificationDialogGetActJWT = (
  props: PhoneNumberVerificationDialogGetActJWTProps,
) => {
  const {
    hero,
    title,
    subtitle,
    resourceType,
    resourceId,
    initialPhoneNumber,
    allowedPhoneNumber,
    anchorButton,
    onClose,
    onSuccess,
  } = props

  const verifyPhoneNumberMutation = usePhoneNumberVerifyForResource()

  const verifyPhoneNumber = async (
    phoneNumber: PhoneNumberInput,
    verificationCode: string,
  ): Promise<void | VerifyPhoneNumberFailureFragment> => {
    if (verificationCode.length !== 6) {
      throw new Error('Verification code must 6 digits.')
    }
    try {
      const result = await verifyPhoneNumberMutation.mutateAsync({
        phoneNumber,
        verificationCode,
        resourceType,
        resourceId,
      })
      if (result.__typename === 'PhoneNumberVerifyForResourceSuccess') {
        onSuccess(result.jwt)
      } else {
        return result
      }
    } catch (error) {
      throw new Error(error?.toString() ?? 'Failed to verify phone number.')
    }
  }

  return (
    <PhoneNumberVerificationDialog
      isOpen={true}
      title={title}
      subtitle={subtitle}
      hero={hero}
      allowedPhoneNumber={allowedPhoneNumber}
      anchorButton={anchorButton}
      resourceType={
        resourceType === VerifyPhoneNumberResourceType.ActRecipient
          ? 'GIFT_CARD'
          : 'OTHER'
      }
      isCreateOrLogin={false}
      shouldDisplaySmsOptIn={false}
      initialPhoneNumber={initialPhoneNumber}
      verifyPhoneNumber={verifyPhoneNumber}
      validateButtonTitle="Send Code"
      onClose={onClose}
    />
  )
}
